<template>

  <div>
    <div v-if="emailToBeConfirm === false">

      <div class="login-container">
        <div class="row">
          <div class="col-md-12">
            <div class="text-center m-b-md">
              <h3>{{ $t('signIn.title') }}</h3>
              <small>{{ $t('signIn.sub_title') }}</small>
            </div>
            <div class="hpanel">
              <div class="panel-body">

                <form v-on:submit="login" action="#" method="post" id="loginForm">
                  <div class="form-group">
                    <label class="control-label required" for="email">{{ $t('signIn.form_email.label') }}</label>
                    <input v-model="email" type="text" v-bind:placeholder="$t('signIn.form_email.place_holder')"
                           v-bind:title="$t('signIn.form_email.title')" required value="" name="email" id="email"
                           class="form-control">
                  </div>
                  <div class="form-group">
                    <label class="control-label required" for="password">{{ $t('signIn.form_password.label') }}</label>
                    <input v-model="password" type="password" v-bind:title="$t('signIn.form_password.title')"
                           v-bind:placeholder="$t('signIn.form_password.place_holder')" required value="" name="password"
                           id="password" class="form-control" autocomplete="false">
                  </div>

                  <div v-if="errorLogin !== null" class="alert alert-danger" style="margin: 10px 0">
                    {{errorLogin}}
                  </div>

                  <div class="checkbox checkbox-info">
                    <input type="checkbox" checked id="rememberMe" v-model="rememberMe">
                    <label for="rememberMe">{{ $t('signIn.form_remember.label') }}</label>
                    <p class="help-block small">({{ $t('signIn.form_remember.help_block') }})</p>
                  </div>

                  <vue-ladda type="submit" :loading="submitLogin.loading" class="btn btn-info btn-block" :data-style="submitLogin.dataStyle">{{ $t('signIn.form.login') }}</vue-ladda>
                  <router-link :to="{name: 'RegisterExpert'}" class="btn btn-default btn-block">{{ $t('signIn.form.register') }}</router-link>
                  <div class="text-center" style="margin-top: 10px">
                    <router-link :to="{name: 'ForgotPassword'}" class="text-info">Forgot password</router-link>
                  </div>
                  <div style="text-align: right;margin-top: 10px">
                    <span style="font-style: italic;font-size: 12px">(<span style="color: red">*</span>) required fields</span>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12 text-center">
            <strong><a href="https://www.idexlab.com" target="_blank"> IDEXLAB</a></strong><br/> {{year}} Copyright Idexlab
          </div>
        </div>
      </div>

    </div>
    <div v-else>
      <enable-account v-bind:email="email"/>
    </div>
  </div>
</template>

<script>

import EnableAccount from './EnableAccount'
import VueLadda from 'vue-ladda'

export default {
  components: {EnableAccount, VueLadda},
  name: 'LoginExpert',
  methods: {
    login: function (event) {
      event.preventDefault()
      this.submitLogin.loading = true

      let redirect = this.$auth.redirect()

      this.$auth.login({
        data: {email: this.email.trim(), password: this.password, ip: this.ip},
        redirect: {name: (redirect ? redirect.from.name : 'ReceiveQuestions'), params: redirect ? redirect.from.params : {}},
        success: (response) => {
          this.$auth.token(null, response.data.access_token)
          localStorage.setItem('is_already_connect', 'true')
          this.submitLogin.loading = false
        },
        error: (res) => {
          this.password = ''
          if (res.response.status === 400) {
            let errors = res.response.data.errors
            switch (res.response.data.code) {
              case 1:
                this.errorLogin = errors['email'][0]
                break
              case 2:
                this.errorLogin = errors['credentials'][0]
                break
              case 3:
                this.emailToBeConfirm = true
                break
            }
          }
          this.submitLogin.loading = false
        },
        rememberMe: this.rememberMe,
        fetchUser: true
      })
    },
    getUserIP: function () {
      this.axios.get('https://ipinfo.io/json')
        .then((response) => {
          if (typeof response.data.ip !== 'undefined' && typeof response.data.ip !== 'undefined' && response.data.ip !== null) {
            this.ip = response.data.ip
          }
        }).catch(function (error) {
        })
    }
  },
  mounted () {
  },
  beforeMount () {
    this.getUserIP()
  },
  data () {
    return {
      email: typeof this.$route.params.email !== 'undefined' ? this.$route.params.email : '',
      password: '',
      ip: '',
      rememberMe: false,
      emailToBeConfirm: false,
      errorLogin: null,
      submitLogin: {
        loading: false,
        'dataStyle': 'zoom-in'
      },
      year: new Date().getFullYear()
    }
  },
  created () {
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/login/LoginExpert.vue